import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { IAutomatedEmailCampaignListPayload } from 'wisestep-api';
import { WsColors, WsTypography } from 'wisestep-base';

import { getDeliveryStats } from '../../../../features/jobsCrm/components/helper/JobsCrmHelper';
import useGetJobCampaignAnalytics from '../../hooks/useGetJobCampaignAnalytics';
import {
  getCampaignAnalyticsColumns,
  getJobEmailCampaignAnalyticsPayload,
} from '../../util/JobCampaignEmailHelper';

export const EmailCampaignAnalytics = () => {
  const [params] = useSearchParams();
  const jobId = params.get('jobId') ?? '';
  const campaignCode = params.get('campaignCode') ?? '';
  const [analyticsParams] = useState<IAutomatedEmailCampaignListPayload>(
    getJobEmailCampaignAnalyticsPayload(jobId, campaignCode)
  );
  const { analytics } = useGetJobCampaignAnalytics(analyticsParams);
  const campaignSummaryStats = getDeliveryStats(analytics?.resultSet);
  return (
    <>
      <WsTypography bold>Delivery Metics</WsTypography>
      <Box sx={{ background: WsColors.White, height: 500, width: 500 }}>
        <DataGrid
          columns={getCampaignAnalyticsColumns()}
          rows={
            Object.values(campaignSummaryStats).map((stat, index) => ({
              id: index,
              ...stat,
            })) ?? []
          }
          pageSize={10}
          rowsPerPageOptions={[10]}
        />
      </Box>
    </>
  );
};
